module.exports = __webpack_public_path__ + "media/success(1).de8a30c2.wav";